<template>
  <div class="basic-info-box">
    <loading :isShow="$root.$children[0].isShowLoading" />

    <div class="info-line">
      <div class="basic-item">
        <span class="label">姓名</span>
        <span class="value">{{ basiInfo.name }}</span>
      </div>

      <div class="basic-item">
        <span class="label">手机号</span>
        <span class="value" v-if="basiInfo.eyeShow">{{ basiInfo.mobile11 }}</span>
        <span class="value" v-else>{{ basiInfo.mobile1 }}</span>
        <a class="action-icon" v-if="basiInfo.mobile1">
          <i class="iconfont iconxianshi eye-icon eye" v-if="basiInfo.eyeShow" @click="openEye(basiInfo,'eyeShow','mobile1')"></i>
          <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(basiInfo,'eyeShow','mobile1')"></i>
        </a>
      </div>

      <div class="basic-item">
        <span class="label">性别</span>
        <span class="value">{{ filter.filterSex(basiInfo.sex) }}</span>
      </div>

      <div class="basic-item">
        <span class="label">生日</span>
        <span class="value">{{ basiInfo.birthDate }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item">
        <span class="label">证件类型</span>
        <span class="value">{{ filter.filterCardType(basiInfo.cardType) }}</span>
      </div>

      <div class="basic-item">
        <span class="label">证件号</span>
        <span class="value" v-if="basiInfo.eyeShow1">{{ basiInfo.cardNo11 }}</span>
        <span class="value" v-else>{{ basiInfo.cardNo1 }}</span>
        <a class="action-icon" v-if="basiInfo.cardNo1">
          <i class="iconfont iconxianshi eye-icon eye" v-if="basiInfo.eyeShow1" @click="openEye(basiInfo,'eyeShow1','cardNo1')"></i>
          <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(basiInfo,'eyeShow1','cardNo1')"></i>
        </a>
      </div>

      <div class="basic-item">
        <span class="label">证件有效期</span>
        <span class="value" v-if="basiInfo.isLong==0">{{ basiInfo.cardStartDate }}-{{ basiInfo.cardEndDate }}</span>
        <span class="value" v-else>长期有效</span>
      </div>

      <div class="basic-item">
        <span class="label">年龄</span>
        <span class="value">{{ basiInfo.age }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item">
        <span class="label">所在地区</span>
        <span class="value">{{ basiInfo.province }}{{ basiInfo.city }}{{ basiInfo.area }}</span>
      </div>

      <div class="basic-item" style="width:50%;">
        <span class="label">详细地址</span>
        <span class="value" style="width:calc(50% + 240px);" v-if="basiInfo.eyeShow2">{{ basiInfo.address1 }}</span>
        <span class="value" style="width:calc(50% + 240px);" v-else>{{ basiInfo.address }}</span>
        <a class="action-icon" v-if="basiInfo.address">
          <i class="iconfont iconxianshi eye-icon eye" v-if="basiInfo.eyeShow2" @click="openEye(basiInfo,'eyeShow2','address')"></i>
          <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(basiInfo,'eyeShow2','address')"></i>
        </a>
      </div>

      <div class="basic-item">
        <span class="label">职业</span>
        <span class="value">{{ basiInfo.profession }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item">
        <span class="label">微信昵称</span>
        <span class="value">{{ basiInfo.nickname?basiInfo.nickname:'-' }}</span>
        <a class="action-icon" v-if="basiInfo.nickname" @click="copyWechat(basiInfo.nickname)">
          <img src="@/assets/images/icon/org/copy.png"/>
        </a>
      </div>

      <div class="basic-item">
        <span class="label">民族</span>
        <span class="value">{{ basiInfo.nation }}</span>
      </div>

      <div class="basic-item">
        <span class="label">邮箱</span>
        <span class="value" v-if="basiInfo.eyeShow3">{{ basiInfo.email1 }}</span>
        <span class="value" v-else>{{ basiInfo.email }}</span>
        <a class="action-icon" v-if="basiInfo.email">
          <i class="iconfont iconxianshi eye-icon eye" v-if="basiInfo.eyeShow3" @click="openEye(basiInfo,'eyeShow3','email')"></i>
          <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(basiInfo,'eyeShow3','email')"></i>
        </a>
      </div>

      <div class="basic-item">
        <span class="label">身高(cm)</span>
        <span class="value">{{ basiInfo.height }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item">
        <span class="label">体重（kg）</span>
        <span class="value">{{ basiInfo.weight }}</span>
      </div>

      <div class="basic-item">
        <span class="label">家庭关系</span>
        <span class="value">{{ setFamilyRelations(basiInfo.familyRelationship) }}</span>
      </div>

      <div class="basic-item">
        <span class="label">身体情况</span>
        <span class="value">{{ setHealth(basiInfo.health) }}</span>
      </div>

      <div class="basic-item">
        <span class="label">有无社保</span>
        <span class="value">{{ basiInfo.socialSecurity=='1'?'有':'无' }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item">
        <span class="label">年收入（万元）</span>
        <span class="value">{{ basiInfo.income }}</span>
      </div>

      <div class="basic-item">
        <span class="label">贷款（元）</span>
        <span class="value">{{ basiInfo.liabilities }}</span>
      </div>

      <div class="basic-item">
        <span class="label">月支出（元）</span>
        <span class="value">{{ basiInfo.spend }}</span>
      </div>

      <div class="basic-item">
        <span class="label">保险预算（元）</span>
        <span class="value">{{ basiInfo.budget }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item">
        <span class="label">客户来源</span>
        <span class="value">{{ filterSource(basiInfo.source)}}</span>
      </div>

      <div class="basic-item">
        <span class="label">为谁配置保险</span>
        <span class="value">{{ filterInsuranceConfig(basiInfo.forWhoInsured) }}</span>
      </div>

      <div class="basic-item">
        <span class="label">是否购买商业险</span>
        <span class="value">{{ basiInfo.businessRisk=='1'?'是':'否' }}</span>
      </div>

      <div class="basic-item">
        <span class="label">关注的产品</span>
        <span class="value">{{ basiInfo.focusProductName }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item">
        <span class="label">咨询次数</span>
        <span class="value">{{ basiInfo.consultNum }}</span>
      </div>

      <div class="basic-item">
        <span class="label">客户需求</span>
        <span class="value">{{ filterCustomerDemand(basiInfo.demand) }}</span>
      </div>

      <div class="basic-item">
        <span class="label">创建时间</span>
        <span class="value">{{ filter.filterTime(basiInfo.createDate, 'YYYY-MM-DD HH:mm') }}</span>
      </div>

      <div class="basic-item">
        <span class="label">归属机构</span>
        <span class="value">{{ basiInfo.organizationName }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item">
        <span class="label">归属团队</span>
        <span class="value">{{ basiInfo.groupName }}</span>
      </div>

      <div class="basic-item">
        <span class="label">归属业务员</span>
        <span class="value">{{ basiInfo.agentName }}</span>
      </div>

      <div class="basic-item">
        <span class="label">最新预约时间</span>
        <span class="value">{{ filter.filterTime(basiInfo.lastSubscribeDate, 'YYYY-MM-DD HH:mm') }}</span>
      </div>

      <div class="basic-item">
        <span class="label">客户类型</span>
        <span class="value">{{ basiInfo.type=='1'?'预约客户':'自有客户' }}</span>
      </div>
    </div>

    <div class="info-line">
      <div class="basic-item" style="width:50%;">
        <span class="label">备注</span>
        <span class="value" style="width:calc(50% + 240px);">{{ basiInfo.remark }}</span>
      </div>
    </div>

    <div class="info-other">
      <div class="info-other-item" v-for="(item, index) in extraFileds" :key="index">
        <span class="label">{{ item.name }}</span>
        <span class="value">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getCustomerDemand, getConfigInsurance, getHealth, getFamilyRelations } from "../../form/api";
import filter from "@/api/filter";
import {common} from "@/api/mixins";

export default {
  name: "detailBasicInfo",
  props:['id'],
  mixins:[common],
  data() {
    return {
      customerDemandList:[],
      insuranceConfigList:[],
      healthList:[],//健康状况
      sourceList: [],//客户来源
      familyRelations:[],//家庭关系
      basiInfo:{},
      httpCode:null,
      filter,
      eyeShow:false,
      extraFileds:[]
    };
  },
  created(){
    this.queryCustomerDemand();
    this.queryConfigInsurance();
    this.queryHealth();
    this.queryFamilyRelations();
    this.getInsureList();
  },
  methods: {
    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/customerBase/read/detail",
        type: "GET",
        data: {
          id:this.id
        },
      }).then((res) => {
        this.getSourceList(res.data.type);
        this.$root.$children[0].isShowLoading = false;
        this.basiInfo = res.data;
        if(res.data.extraFileds){
          this.extraFileds = JSON.parse(res.data.extraFileds);
        }
      }).catch((e) => {
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 家庭关系
    async queryFamilyRelations() {
      const { data } = await getFamilyRelations();
      this.familyRelations = data;
    },

    setFamilyRelations(value) {
      if(!value) return '-';
      let str = '';
      this.familyRelations.map(item=>{
        if(item.value == value){
          str = item.txt;
        }
      })
      return str;
    },

    // 健康状况
    async queryHealth() {
      const {data} = await getHealth();
      this.healthList = data;
    },

    setHealth(value) {
      if(!value) return '-';
      let str = '';
      this.healthList.map(item=>{
        if(item.value == value){
          str = item.txt;
        }
      })
      return str;
    },

    // 客户需求
    async queryCustomerDemand() {
      const {data} = await getCustomerDemand();
      this.customerDemandList = data;
    },

    // 为谁配置保险
    async queryConfigInsurance() {
      const {data} = await getConfigInsurance();
      this.insuranceConfigList = data;
    },

    // 客户需求
    filterCustomerDemand(value) {
      if(!value)return;
      let str = [];
      this.customerDemandList.filter(item=>{
        value.split(',').map(item2=>{
          if(item.value == item2){
            str.push(item.txt)
          }
        })
      })
      return str.join('、')
    },

    // 为谁配置保险
    filterInsuranceConfig(value){
      if(!value)return;
      let str = [];
      this.insuranceConfigList.filter(item=>{
        value.split(',').map(item2=>{
          if(item.value == item2){
            str.push(item.txt)
          }
        })
      })
      return str.join('、')
    },

    // 客户来源
    getSourceList(type){
      this.$http({
        url: "/buz/subscribe/querySourceList",
        type: "PUT",
        data:{type}
      }).then((res) => {
        this.sourceList = res.data;
      })
    },

    filterSource(value) {
      if(!value)return;
      const result = this.sourceList.filter(item=>item.code == value);
      return result[0]&&result[0].name;
    },

    // 微信昵称复制
    copyWechat(value) {
      let oInput = document.createElement("input");
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$Message.success("复制成功");
    },
    openEye(item,keyName,name){
      let operationType,otherInfo
        otherInfo={
          type:1
        }
      if( name == 'mobile1'){
        operationType=2
      }else if( name =='cardNo1'){
        operationType=1
      }else if( name == 'address'){
        operationType = 5
      }else if( name == 'email'){
        operationType = 4
      }
      if(!item[keyName]){
        this.descrypt({
          query:item.id,
          operationFunction:6,
          operationType:operationType,
          otherInfo:otherInfo
        },item,name+'1','orderInuser_6_1').then(()=>{
          this.$set(item, keyName, true);
          console.log(item)
        })
      }else{
        this.$set(item, keyName, false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-info-box {
  .info-line {
    width: 100%;
    margin-bottom: 20px;
    display: flex;

    .basic-item {
      width: 25%;
      display: flex;
      align-items: center;
      .label {
        width: 90px;
        text-align: right;
        font-size: 12px;
        color: #727c8e;
        white-space: nowrap;
      }
      .value {
        padding: 0 10px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        margin-left: 10px;
        width: 240px;
        height: 30px;
        font-size: 12px;
        color: #515c6f;
        background-color: #f5f7f9;
        white-space: nowrap;
        overflow: hidden;
        overflow-x: auto;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
      }
      .value::-webkit-scrollbar{
        display:none;
      }
      .value:hover {
        cursor: not-allowed;
      }
      .action-icon {
        color: none;
        margin-left: 8px;
        img {
          width: 16px;
          height: 16px;
        }
        .eye {
          color: #A8ADB7;
        }
      }
    }
  }
  .info-other {
    display: flex;
    flex-wrap: wrap;
    .info-other-item {
      display: flex;
      align-items: center;
      width: 25%;
      margin-bottom: 20px;
      .label {
        width: 90px;
        text-align: right;
        font-size: 12px;
        color: #727c8e;
        white-space: nowrap;
      }
      .value {
        padding: 0 10px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        margin-left: 10px;
        width: 240px;
        height: 30px;
        color: #515c6f;
        background-color: #f5f7f9;
        white-space: nowrap;
        overflow: hidden;
        overflow-x: auto;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
      }
      .value:hover {
        cursor: not-allowed;
      }
    }
  }
}
</style>